<!-- file-upload.component.html -->
<div class="wrapper">
  <div class="row table-toolbar">
      <div class="cal-xl-4 col-lg-4 col-md-12 col-sm-12">
        <div class="file-upload-container">
            <input type="file" (change)="onFileSelect($event)" multiple />
            <button (click)="onSubmit()">Upload</button>
          
            <div *ngIf="errorMessage" class="error-message">
              {{ errorMessage }}
            </div>
          
            <div *ngIf="fileNames.length > 0">
              <h3>Selected Files:</h3>
              <ul>
                <li *ngFor="let name of fileNames">{{ name }}</li>
              </ul>
            </div>
        </div>
      </div>
  </div>
</div>

  